module.exports = " <div class=vux-alert> <dialog class=weui_dialog_alert :show=show :mask-transition=maskTransition :dialog-transition=dialogTransition @on-hide=\"$emit('on-hide')\" @on-show=\"$emit('on-show')\"> <div class=weui_dialog_hd><strong class=weui_dialog_title>{{title}}</strong></div> <div class=weui_dialog_bd><slot></slot></div> <div class=weui_dialog_ft> <a href=javascript:; class=\"weui_btn_dialog primary\" @click=onHide>{{buttonText}}</a> </div> </dialog> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.3@vue-html-loader!./~/.8.7.0@vue-loader/lib/selector.js?type=template&index=0!./~/.0.1.3@vux/src/components/alert/index.vue
// module id = 200
// module chunks = 2